const categoryCards = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Closeup%20angled%20shot%20of%20designer%20sneakers%20on%20polished%20wooden%20floor%20with%20natural%20sunlight%20streaming%20through%20window%20blinds%2C%20luxury%20footwear%20product%20photography%2C%20rich%20warm%20wood%20tones%2C%20dramatic%20light%20and%20shadow%20play%2C%20premium%20editorial%20aesthetic&width=600&height=750&seq=cat-v2-shoes&orientation=portrait',
    description: 'Sneakers exclusivos com os melhores preços',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20hoodie%20hanging%20on%20minimal%20wooden%20hanger%20against%20warm%20terracotta%20painted%20wall%2C%20soft%20afternoon%20light%20from%20side%20window%2C%20cozy%20lifestyle%20fashion%20photography%2C%20textured%20fabric%20detail%2C%20earthy%20warm%20color%20palette%2C%20scandinavian%20interior%20vibe&width=600&height=750&seq=cat-v2-hoodies&orientation=portrait',
    description: 'Hoodies e sweaters de alta qualidade',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20cotton%20t-shirts%20in%20stack%20overhead%20flat%20lay%20on%20textured%20linen%20fabric%20surface%2C%20soft%20morning%20light%2C%20organic%20minimalist%20product%20photography%2C%20natural%20earthy%20neutral%20colors%2C%20clean%20composition%20with%20gentle%20fabric%20wrinkles&width=600&height=750&seq=cat-v2-tshirts&orientation=portrait',
    description: 'T-shirts com designs exclusivos',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20worn%20by%20person%20walking%20in%20modern%20urban%20street%20with%20autumn%20leaves%2C%20candid%20lifestyle%20fashion%20photography%2C%20golden%20hour%20backlight%2C%20cinematic%20mood%2C%20city%20background%20with%20warm%20bokeh%20effect&width=600&height=750&seq=cat-v2-jackets&orientation=portrait',
    description: 'Jaquetas modernas para todas as estações',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Casual%20linen%20pants%20draped%20gracefully%20over%20vintage%20wooden%20chair%20in%20sunlit%20cozy%20room%20corner%2C%20natural%20light%20through%20sheer%20curtains%2C%20relaxed%20lifestyle%20photography%2C%20warm%20soft%20atmosphere%2C%20home%20interior%20aesthetic&width=600&height=750&seq=cat-v2-pants&orientation=portrait',
    description: 'Calças e shorts para todos os estilos',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20baseball%20cap%20resting%20on%20stack%20of%20vintage%20fashion%20books%20with%20warm%20desk%20lamp%20glow%2C%20cozy%20study%20room%20atmosphere%2C%20soft%20ambient%20lighting%2C%20intellectual%20lifestyle%20product%20photography%2C%20dark%20academia%20aesthetic&width=600&height=750&seq=cat-v2-headwear&orientation=portrait',
    description: 'Bonés e acessórios de cabeça',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20outfit%20laid%20beautifully%20on%20white%20crumpled%20bed%20sheets%20with%20morning%20sunlight%20through%20window%20blinds%20creating%20stripe%20shadows%2C%20soft%20dreamy%20fashion%20photography%2C%20peaceful%20weekend%20morning%20mood&width=600&height=750&seq=cat-v2-sets&orientation=portrait',
    description: 'Conjuntos coordenados exclusivos',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20basics%20neatly%20rolled%20and%20arranged%20inside%20open%20wooden%20drawer%20with%20soft%20warm%20light%2C%20intimate%20bedroom%20lifestyle%20photography%2C%20cozy%20organic%20aesthetic%2C%20natural%20textures%2C%20slow%20living%20vibe&width=600&height=750&seq=cat-v2-underwear&orientation=portrait',
    description: 'Roupas íntimas de qualidade premium',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20hanging%20on%20metal%20locker%20room%20hook%20with%20dramatic%20stadium%20spotlight%20effect%2C%20athletic%20gear%20photography%2C%20dark%20moody%20background%20with%20focused%20light%20beam%2C%20sport%20documentary%20style%2C%20intense%20atmosphere&width=600&height=750&seq=cat-v2-jersey&orientation=portrait',
    description: 'Jerseys esportivas autênticas',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20watch%20and%20minimalist%20bracelet%20displayed%20on%20white%20marble%20surface%20with%20fresh%20green%20plant%20leaf%20nearby%2C%20luxury%20jewelry%20display%20photography%2C%20natural%20side%20lighting%2C%20sophisticated%20boutique%20aesthetic%2C%20clean%20refined%20composition&width=600&height=750&seq=cat-v2-accessories&orientation=portrait',
    description: 'Acessórios de moda tendência',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20leather%20tote%20bag%20on%20outdoor%20cafe%20table%20with%20sunlight%20filtering%20through%20green%20plants%2C%20European%20street%20cafe%20lifestyle%20photography%2C%20warm%20golden%20afternoon%20light%2C%20casual%20chic%20aesthetic%2C%20blurred%20background%20with%20cobblestone%20street&width=600&height=750&seq=cat-v2-bags&orientation=portrait',
    description: 'Bolsas e mochilas premium',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belt%20elegantly%20curled%20on%20rustic%20reclaimed%20wood%20workbench%20with%20artisan%20tools%20in%20background%2C%20warm%20workshop%20lighting%2C%20craftsmanship%20photography%2C%20rich%20brown%20leather%20textures%2C%20authentic%20maker%20aesthetic&width=600&height=750&seq=cat-v2-belts&orientation=portrait',
    description: 'Cintos de couro e moda',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20fragrance%20bottle%20surrounded%20by%20fresh%20pink%20roses%20and%20scattered%20petals%20on%20vanity%20table%20with%20vintage%20mirror%20reflection%2C%20feminine%20beauty%20product%20photography%2C%20soft%20romantic%20candlelight%20glow%2C%20elegant%20boudoir%20aesthetic&width=600&height=750&seq=cat-v2-perfumes&orientation=portrait',
    description: 'Perfumes e fragrâncias exclusivas',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mixed%20fashion%20accessories%20and%20small%20items%20artfully%20arranged%20inside%20open%20vintage%20suitcase%20on%20wooden%20floor%2C%20travel%20preparation%20scene%2C%20warm%20nostalgic%20lighting%2C%20adventure%20lifestyle%20photography%2C%20eclectic%20curated%20collection%20aesthetic&width=600&height=750&seq=cat-v2-other&orientation=portrait',
    description: 'Outros itens e achados especiais',
  },
];

const cardBackgrounds = [
  'bg-accent-100/70',
  'bg-secondary-100/70',
  'bg-background-200/90',
  'bg-accent-50/80',
];

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-2">
            Escolha por Categoria
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Explore Nossas<br />
            <span className="italic font-normal text-accent-600">Categorias Populares</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categoryCards.slice(0, 8).map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group cursor-pointer rounded-xl overflow-hidden transition-transform duration-300 hover:-translate-y-1"
            >
              <div className={`${cardBackgrounds[idx % 4]} aspect-[4/5] relative overflow-hidden`}>
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-sm md:text-base font-bold text-white leading-tight whitespace-nowrap drop-shadow-md">{cat.name}</p>
                  <p className="text-xs text-white/80 mt-1 leading-snug drop-shadow">{cat.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {categoryCards.slice(8, 14).map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group cursor-pointer rounded-xl overflow-hidden transition-transform duration-300 hover:-translate-y-1"
            >
              <div className={`${cardBackgrounds[idx % 4]} aspect-[4/5] relative overflow-hidden`}>
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-sm md:text-base font-bold text-white leading-tight whitespace-nowrap drop-shadow-md">{cat.name}</p>
                  <p className="text-xs text-white/80 mt-1 leading-snug drop-shadow">{cat.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}